import { useQuery } from '@tanstack/react-query';
import apiInputService from 'services/apiInputService';

export interface Report {
  _id: string;
  fileName: string;
  updatedAt: string;
}

export const getAvailableReports = async () => {
  const { data } = await apiInputService.get('/report',);

  return data as Report[];
};

export const useAvailableReports = ( options?: any) => {
  return useQuery(
    ['availableReports'],
    () => getAvailableReports(),
    {
      ...options,
    }
  );
};